import styled from "styled-components";
import { MixpanelTracking } from "../../MixPanel";

const StyledButton = styled.button`
	&:disabled {
		opacity : 0.5;
	}
`
function Button(props: any) {
	const type = props.type || ''

	const handleOnClick = () => {
		if(props.onClick)
			props.onClick();
		
		const mixPanelData = {
			buttonName : String(props.children),
			destinationEvent : props.destinationEvent ? props.destinationEvent : ''
		}

		MixpanelTracking.getInstance().buttonClicked(mixPanelData);
	}

	return (
		<StyledButton
			className={`${props.styles} flex justify-center items-center`}
			style={{
				width: props.width,
				height: props.height,
				borderRadius: props.borderRadius,
			}}
			onClick={handleOnClick}
			type={type}
			disabled={props.disabled}
		>
			{props.children}
			{
				props.loader && 
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 animate-spin ml-2">
					<path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
				</svg>
			}
		</StyledButton>
	)
}

Button.defaultProps = {
	disabled: false,
	loader : false,
	borderRadius : 6
}

export default Button